import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  LayoutDashboard, BarChart3,
  Bell, Users, UserCircle, Flag,
  ChevronLeft, ChevronRight, BadgeDollarSign
} from 'lucide-react';
import { FaFlagCheckered } from "react-icons/fa";
import { useSelector } from "react-redux";
import './Sidebar.css';

const navItems = [
  { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard, group: 'main' },
  { path: '/users', label: 'Users', icon: Users, group: 'main' },
  { path: '/subscription', label: 'Subscription ', icon: BadgeDollarSign, group: 'main' },
  // { path: '/notifications', label: 'Push Notification',  icon: Bell,            group: 'notification' },
  //   { path: '/feedback',      label: 'Feedback',           icon: MessageSquare,   group: 'racing' },
  { path: '/profile', label: 'Admin Profile', icon: UserCircle, group: 'account' },
];

const groups = {
  main: 'Main',
  // notification:  'Notification',
  account: 'Account',
};

function Sidebar({ collapsed, onToggle, mobileOpen, onMobileClose }) {
  const location = useLocation();

  const { admin } = useSelector((state) => state.admin);
  const initials = admin?.name
    ? admin.name.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2)
    : "A";

  // Group nav items
  const grouped = Object.keys(groups).map(key => ({
    key,
    label: groups[key],
    items: navItems.filter(n => n.group === key),
  }));

  return (
    <>
      {/* Mobile overlay */}
      {mobileOpen && (
        <div className="sidebar-overlay" onClick={onMobileClose} />
      )}

      <aside className={`sidebar ${collapsed ? 'collapsed' : ''} ${mobileOpen ? 'mobile-open' : ''}`}>
        {/* Logo */}
        <div className="sidebar-logo">
          <div className="logo-icon">
            <FaFlagCheckered size={20} />
          </div>
          {!collapsed && (
            <div className="logo-text">
              <span className="logo-name font-display">Vegas Karts</span>
              <span className="logo-sub">Admin Panel</span>
            </div>
          )}
        </div>

        {/* Nav */}
        <nav className="sidebar-nav">
          {grouped.map(group => (
            <div key={group.key} className="nav-group">
              {!collapsed && (
                <span className="nav-group-label">{group.label}</span>
              )}
              {group.items.map(item => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;
                return (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    className={`nav-item ${isActive ? 'active' : ''}`}
                    onClick={onMobileClose}
                    title={collapsed ? item.label : ''}
                  >
                    <span className="nav-icon"><Icon size={18} /></span>
                    {!collapsed && <span className="nav-label">{item.label}</span>}
                    {isActive && !collapsed && <span className="nav-indicator" />}
                  </NavLink>
                );
              })}
            </div>
          ))}
        </nav>

        {/* Footer */}
        <div className="sidebar-footer">
          {!collapsed && (
            <div className="sidebar-user">
              <div className="sidebar-avatar"> 
                {admin?.profilePic ? (
                <img
                  src={admin?.profilePic}
                  alt={admin?.name}
                  className="sidebar-avatar-img"
                />
              ) : (
                <img
                  src={admin?.profilePic || "/images/profile.jpg"}
                  alt={admin?.name}
                  className="sidebar-avatar-img"
                />
              )}</div>
              <div className="sidebar-user-info">
                <span className="sidebar-user-name">{admin?.name || "Vegas Karts"}</span>
                <span className="sidebar-user-role">{admin?.email || "admin@vegas.com"}</span>
              </div>
            </div>
          )}
          <button className="sidebar-toggle-btn" onClick={onToggle} title={collapsed ? 'Expand' : 'Collapse'}>
            {collapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
          </button>
        </div>
      </aside>
    </>
  );
}

export default Sidebar;
export { navItems };